import { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import FormControl from '@mui/material/FormControl';

export default function MaterialUIPickers({ etiqueta , fechaPublicacion}) {

    const [value, setValue] = useState(fechaPublicacion);

    const handleChange = (newValue) => {
        setValue(newValue);
    };

    return (
        <FormControl sx={{ width: 200 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={3}>
                    <DesktopDatePicker
                        label={etiqueta}
                        inputFormat="DD/MM/YYYY"
                        value={value}
                        onChange={handleChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                        '& .MuiInputBase-input': {
                                            padding: '7.6px 14px', 
                                        },
                                    },
                                }}
                               
                            />
                        )}
                    />

                </Stack>
            </LocalizationProvider>
        </FormControl>

    );
}
